import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import settingsEN from "./en/accountSettingsEN.json";
import chartEN from "./en/chartEN.json";
import commonEN from "./en/commonsEN.json";
import dashboardEN from "./en/dashboardEN.json";
import libraryEN from "./en/libraryEN.json";
import modalEN from "./en/modalEN.json";
import sidebarEN from "./en/sidebarEN.json";
import toastEN from "./en/toastsEN.json";
import settingsSV from "./sv/accountSettingsSV.json";
import chartSV from "./sv/chartSV.json";
import commonSV from "./sv/commonsSV.json";
import dashboardSV from "./sv/dashboardSV.json";
import librarySV from "./sv/librarySV.json";
import modalSV from "./sv/modalSV.json";
import sidebarSV from "./sv/sidebarSV.json";
import toastSV from "./sv/toastsSV.json";
import passwordEN from "./en/passwordEN.json";
import passwordSV from "./sv/passwordSV.json";
import validationsEN from "./en/validationsEN.json";
import validationsSV from "./sv/validationsSV.json";
import onboardingEN from "./en/onboardingEN.json";
import onboardingSV from "./sv/onboardingSV.json";

export const LANGUAGE_STORAGE_KEY = "language";

export const languages = {
  english: {
    code: "en",
    translationKey: "commons.languages.english",
  },
  swedish: {
    code: "sv",
    translationKey: "commons.languages.swedish",
  },
} as const;

export function getLangLabels(
  t: (key: string) => string,
): Record<string, string> {
  return {
    en: t("commons.languages.english"),
    sv: t("commons.languages.swedish"),
  };
}

const initLang = () =>
  localStorage.getItem(LANGUAGE_STORAGE_KEY) ?? languages.english.code;

const resources = {
  en: {
    translation: {
      ...libraryEN,
      ...dashboardEN,
      ...chartEN,
      ...settingsEN,
      ...onboardingEN,
      ...sidebarEN,
      ...toastEN,
      ...modalEN,
      ...passwordEN,
      ...validationsEN,
      ...commonEN,
    },
  },
  sv: {
    translation: {
      ...librarySV,
      ...dashboardSV,
      ...chartSV,
      ...settingsSV,
      ...sidebarSV,
      ...onboardingSV,
      ...toastSV,
      ...modalSV,
      ...passwordSV,
      ...validationsSV,
      ...commonSV,
    },
  },
};

void i18n.use(initReactI18next).init({
  resources,
  lng: initLang(),
  fallbackLng: "en",
});

export default i18n;
